import styled from 'styled-components'
import { height, HeightProps, width, WidthProps } from 'styled-system'
import { themeGet } from '@styled-system/theme-get'

export const MobileContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  width: 100%;
  column-gap: ${themeGet('space.5')}px;
`

export const DesktopContainer = styled.div`
  display: flex;
  justify-items: center;
  align-items: center;
  gap: ${themeGet('space.5')}px;
`

export const Card = styled.div<HeightProps & WidthProps>`
  position: relative;

  > img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  ${height}
  ${width}
`
